import { TopPage } from "@/components/elements/TopPage";
import { OfficeReportList } from "@/features/business-report/components/OfficeReportList";
import { Stack } from "@mui/material";

export const BusinessReportPage = () => {
  return (
    <Stack gap={3}>
      <TopPage title="紹介事業報告書の作成" enablePageBack={false} />
      <OfficeReportList />
    </Stack>
  );
};
